import stylesheet0 from "@oneappexchange/appx-font-utilities";

function stylesheet(token, useActualHostSelector, useNativeDirPseudoclass) {
  var shadowSelector = token ? ("[" + token + "]") : "";
  var hostSelector = token ? ("[" + token + "-host]") : "";
  var suffixToken = token ? ("-" + token) : "";
  return ".section-heading" + shadowSelector + " {margin: 0 0 var(--sds-g-spacing-4) 0;}.card-grid" + shadowSelector + " {display: grid;grid-template-columns: 1fr;gap: var(--sds-g-spacing-4, 1rem);}@media (min-width: 768px) {.card-grid" + shadowSelector + " {grid-template-columns: repeat(2, minmax(0, var(--achievement-and-impact-card-max-width, 1fr)));gap: var(--sds-g-spacing-6, 2rem);}}.card-grid__item" + shadowSelector + " {height: 100%;max-width: 100%;--axds-ovr-card-height: 100%;}";
  /*LWC compiler v7.1.3*/
}
export default [stylesheet0, stylesheet];